// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"c672dec2","66":"db28bd0c","75":"73cadd3e","93":"439f6853","224":"0dcc2074","279":"715a70b4","381":"f9374852","604":"a5ad36bc","612":"b302feea","922":"23423902"}[chunkId] + ".chunk.js";
};